import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames/bind';

import { Popup, Heading, ProductTile, Button, I18n } from 'components';
import { printKbytes } from 'utils/accumulators';
import { closePopup } from 'actions';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const toArray = (input) => {
  if (!input) return [];
  return Array.isArray(input) ? input : [input];
};

const AccumulatorsSpeedUpPopup = ({ data, actions, activePopup }) => {
  if (!data) {
    return null;
  }

  return (
    <Popup
      opened={activePopup === 'accumulatorsSpeedUp'}
      onClose={actions.closePopup}
    >
      <Heading className={cx('heading')} level={1}>
        <I18n path="home.internetExtension.heading" />
      </Heading>
      <div className={cx('description')}>
        <I18n path="home.internetExtension.description" />
      </div>
      {(data.highway || data.oneTime) && (
        <div className={cx('services')}>
          {data.highway && (
            <ProductTile
              className={cx('service')}
              title={data.highway.title}
              description={data.highway.description}
              parameters={data.highway.params}
              link={data.highway.url}
              buttonLink={`${data.highway.url}?connect=true`}
            />
          )}
          {toArray(data.oneTime).map((service) => (
            <ProductTile
              key={service.alias || service.url}
              className={cx('service')}
              title={service.title}
              description={service.description}
              parameters={service.params}
              link={service.url}
              buttonLink={`${service.url}?connect=true`}
            />
          ))}
        </div>
      )}
      {data.auto && (
        <div className={cx('autoSpeedUp')}>
          <div className={cx('autoSpeedUpDescription')}>
            <I18n
              path="home.internetExtension.autoSpeedUpDescription"
              vars={{
                size: printKbytes(data.auto.size),
              }}
            />
          </div>
          {/* TODO: add currency processing */}
          <div className={cx('autoSpeedUpPrice')}>
            <I18n
              path="home.internetExtension.autoSpeedUpPrice"
              vars={{
                price: `${data.auto.price} ₽`,
                size: printKbytes(data.auto.size),
              }}
            />
          </div>
          <div className={cx('autoSpeedUpButton')}>
            <Button className={['default', 'big']} href={data.auto.url}>
              <I18n path="home.internetExtension.autoSpeedUpLink" />
            </Button>
          </div>
        </div>
      )}
    </Popup>
  );
};

function mapStateToProps(state) {
  return {
    data: state.home.internetExtension.data,
    activePopup: state.application.popup,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ closePopup }, dispatch),
  };
}

AccumulatorsSpeedUpPopup.propTypes = {
  actions: PropTypes.object,
  data: PropTypes.object,
  activePopup: PropTypes.string,
};

export default connect(mapStateToProps, mapDispatchToProps)(AccumulatorsSpeedUpPopup);
